import React from 'react';

const removeIcon = () => (
    <svg viewBox="0 0 60 60">
        <path d="M30,0C13.5,0,0,13.5,0,30c0,16.5,13.5,30,30,30c16.5,0,30-13.5,30-30C60,13.5,46.5,0,30,0z
		 M34.887,25.65h11.209v8.701H34.887c-0.296,0,0-0.296,0,0l0,0h-9.774l0,0c-0.896-0.087,0.296,0,0,0H13.904V25.65h11.209"/>
    </svg>
)

export default removeIcon;